import axios from '../axios';

export default {
  getDeviceLogKeys (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/device-log/keys`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDeviceLogs (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/device/${id}/logs`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getLogsNameFile (nameFile) {
    return new Promise((resolve, reject) => {
      axios.post(`/get-logs?name=${nameFile}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
